module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a5410e8125f778e01f7b4fc5da269033.png";